<template>
  <v-overlay :dark="false">
    <v-container fill-height fluid>
      <v-row dense justify="center">
        <v-col>
          <v-sheet color="transparent">
            <v-row dense no-gutters >
              <v-col>
                <v-card
                  max-width="360"
                  flat
                  tile
                  elevation="4"
                  style="z-index: 1"
                  class="px-2"
                  color="cards">
                  <v-container fill-height fluid>
                    <v-col>
                      <v-card-title class="justify-center">
                        <span class="subtitle-1 font-weight-medium">
                          {{ $t("login.loginStandardAccount")}}<span class="ml-2 primary--text">ПИМИС</span>
                        </span>
                      </v-card-title>
                      <v-alert
                        icon="mdi-shield-lock-outline"
                        class="subtitle-2 rounded-0"
                        color="primary"
                        text>
                        <span class="font-weight-medium">
                          {{ $t("login.modalInfo") }}
                        </span>
                      </v-alert>
                      <v-form
                        ref="loginModalform"
                        @submit.prevent="validateBeforeLogin"
                        @keyup.enter="validateBeforeLogin">
                        <v-card-text>
                          <v-row dense no-gutters>
                            <v-col>
                              <v-text-field
                                ref="usernameInput"
                                v-model="user.login"
                                required
                                :label="$t('user.username')"
                                color="primary"
                                :error-messages="loginErrors"
                                @input="$v.user.login.$touch()"
                                @blur="$v.user.login.$touch()"
                                class="subtitle-2"
                                prepend-inner-icon="mdi-account">
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row dense no-gutters>
                            <v-col class="pb-0 mb-0">
                              <v-text-field
                                type="password"
                                required
                                color="primary"
                                v-model="user.password"
                                :label="$t('user.password')"
                                :error-messages="passwordErrors"
                                @input="$v.user.password.$touch()"
                                @blur="$v.user.password.$touch()"
                                class="subtitle-2"
                                prepend-inner-icon="mdi-lock-outline">
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions color="highlight">
                          <v-col>
                            <v-row>
                              <v-col cols="12">
                                <v-btn
                                  tile
                                  color="primary"
                                  type="submit"
                                  :loading="loading"
                                  :class="{ 'disable-events': loading }"
                                  block
                                  class="text-none">
                                  {{ $t("form.submit") }}
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-card-actions>
                      </v-form>
                    </v-col>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>
import Vue from 'vue'
import { login } from '@/router/auth'
import { validationMixin } from '@/mixins/validation'
import { required } from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)

export default {
  name: 'login-modal',
  mixins: [validationMixin],
  data () {
    return {
      loading: false,
      tabs: null,
      user: {
        login: '',
        password: ''
      }
    }
  },
  created () {
    this.$nextTick(() => this.$refs.usernameInput.focus())
  },
  computed: {
    loginErrors () {
      return !this.$v.user.login.$dirty
        ? []
        : this.getUserValidationErrorsByName('login')
    },
    passwordErrors () {
      return !this.$v.user.password.$dirty
        ? []
        : this.getUserValidationErrorsByName('password')
    }
  },
  methods: {
    getUserValidationErrorsByName (name) {
      return this.getValidationErrors('user')
        .filter((x) => {
          return x.field === name
        })
        .map((x) => x.msg)
    },
    validateBeforeLogin () {
      this.$v.$touch()
      const validationErrors = this.getValidationErrors('user')
      if (validationErrors && validationErrors.length > 0) {
        return
      }
      this.login()
    },
    login () {
      this.loading = true
      const loginUrl = Vue.$apiConfig.login
      this.$http.post(loginUrl, this.user).then(
        (response) => {
          const payload = response.data.payload
          login(this.user.login, payload.accessToken, payload.refreshToken)
          this.loading = false
        },
        (error) => {
          this.loading = false
          this.logConsole(error)
          this.formatErrorResponse(error)
        }
      )
    }
  },
  validations: {
    user: {
      login: {
        required
      },
      password: {
        required
      }
    }
  }
}
</script>
